var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"parentDom",staticClass:"winRatePrediction",class:_vm.isAutoExportPng ? 'autoExportPng' : ''},[_c('div',{staticClass:"barEcharts"},[_c('div',{ref:"barEcharts",staticClass:"barEchartsDom",style:({
        height: `${_vm.parentDomHPx ? _vm.parentDomHPx : 'auto'}`,
      }),on:{"click":_vm.clickEchartBox}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }